module.exports = __webpack_public_path__ + "img/pic29.8ce79b09.jpg";